module.exports = __webpack_public_path__ + "static/media/image1.e4c9a31c.png";